import { render, staticRenderFns } from "./HealthCard.vue?vue&type=template&id=ec0ffc7e&scoped=true&"
import script from "./HealthCard.vue?vue&type=script&lang=ts&"
export * from "./HealthCard.vue?vue&type=script&lang=ts&"
import style0 from "./HealthCard.vue?vue&type=style&index=0&id=ec0ffc7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0ffc7e",
  null
  
)

export default component.exports